import script from "./download-receipts-button.vue?vue&type=script&lang=js"
export * from "./download-receipts-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__